import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink } from '../../components';
import css from './ListingPage.module.css';
import { stringify } from 'query-string';

const Breadcrumbs = ({ spiritTypeValue, spiritTypeLabel, spiritTypeParamName, title, intl }) => {
  return (
    <div className={css.breadcrumbs}>
      <NamedLink name="LandingPage">
        <FormattedMessage id="LandingPage.title" defaultMessage="Home" />
      </NamedLink>
      <span className={css.separator}>/</span>
      <NamedLink name="SearchPage">
        <FormattedMessage id="SearchPage.title" defaultMessage="Search" />
      </NamedLink>
      <span className={css.separator}>/</span>
      {spiritTypeValue ? (
        <NamedLink
          name="SearchPage"
          to={{ search: `?${stringify({ [spiritTypeParamName]: spiritTypeValue })}` }}
        >
          {spiritTypeLabel}
        </NamedLink>
      ) : null}
      <span className={css.separator}>/</span>
      <span className={css.current}>{title}</span>
    </div>
  );
};

export default Breadcrumbs;